export default {
    generics: {
        nationalities: [],
        cities: [],
        arrivalModes: [],
        insuranceTypes: [],
        admissionTypes: [],
        maritalStatus: [
            { label: 'single', value: 'S' },
            { label: 'married', value: 'M' },
            { label: 'divorced', value: 'D' },
            { label: 'widowed', value: 'W' }
        ],
        genders: [
            { label: 'male', value: 'M' },
            { label: 'female', value: 'F' },
            { label: 'nonBinary', value: 'O' }
        ]
    },
    message: {
        text: '',
        status: null
    },
    formStructure: null,
    socketCondition: null, // CONNECTED , DISCONNECTED , RECONNECTING, BLOCKED
    realTimeConnection: {
        numberOfRetries: 0,
        firstRetryTime: null,
        status: null
    }
};
